export const EmployeePresentStatus = {
	UNKNOWN: 'unknown',
	IN_MEETING: 'in_meeting',
	HAVING_LUNCH: 'having_lunch',
	NOT_YET_PRESENT: 'not_yet_present',
	PRESENT: 'present',
	WORK_FROM_HOME: 'work_from_home',
	WORK_FROM_HOME_2: 'work_from_home_2',
	LEFT: 'left',
};
